export default {
  rowButtonContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: 'space-evenly'
  }
};
